import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useLanguage } from '../context/LanguageContext';

const MobileLanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const [anchorEl, setAnchorEl] = useState(null);

  const languages = [
    { code: 'sv', name: 'Svenska', shortCode: 'SV', flag: '🇸🇪' },
    { code: 'en', name: 'English', shortCode: 'EN', flag: '🇺🇸' },
    { code: 'de', name: 'Deutsch', shortCode: 'DE', flag: '🇩🇪' }
  ];

  const currentLanguage = languages.find(lang => lang.code === language);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (langCode) => {
    setLanguage(langCode);
    handleClose();
  };

  return (
    <Box>
      <IconButton
        onClick={handleClick}
        sx={{
          color: 'white',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '8px',
          padding: '8px',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <LanguageIcon sx={{ fontSize: '20px' }} />
          <Typography sx={{ fontSize: '14px', fontWeight: 'bold', minWidth: '20px' }}>
            {currentLanguage?.shortCode}
          </Typography>
        </Box>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            backgroundColor: 'rgba(9, 159, 190, 0.95)',
            marginTop: '8px',
            minWidth: '120px',
          }
        }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            selected={language === lang.code}
            sx={{
              color: 'white',
              backgroundColor: language === lang.code ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
              <Typography sx={{ fontSize: '16px' }}>
                {lang.flag}
              </Typography>
              <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                {lang.shortCode}
              </Typography>
              <Typography sx={{ fontSize: '12px', opacity: 0.8, marginLeft: 'auto' }}>
                {lang.name}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default MobileLanguageSwitcher;